import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCreditCardAdd"><Path d="M2.75 9.75005V15.2461C2.75 17.4553 4.54086 19.2461 6.75 19.2461H13.4961M2.75 9.75005V8.75293C2.75 6.54379 4.54086 4.75293 6.75 4.75293H17.2538C19.4584 4.75293 21.2463 6.53671 21.2462 8.74131L21.2461 9.75005M2.75 9.75005H21.2461M21.2461 9.75005V11.2481M19.25 14.25V17.25M19.25 17.25V20.25M19.25 17.25H16.25M19.25 17.25H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCreditCardAdd;
